import React from "react";

const ThemeSuspense = () => {
  return (
    <div className="w-full h-screen flex flex-col items-center justify-center p-6 bg-white dark:bg-gray-900">
      <span className="text-3xl font-bold bg-gradient-to-r from-green-500 to-purple-500 bg-clip-text text-transparent animate-pulse">
        TalkingData.ai
      </span>
      <div className="mt-4 flex items-center space-x-2">
        <div className="w-3 h-3 bg-green-500 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div className="w-3 h-3 bg-green-400 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div className="w-3 h-3 bg-purple-500 rounded-full animate-bounce"></div>
      </div>
    </div>
  );
};

export default ThemeSuspense;